export const USER_AVATAR_SIZE = 200
